import React from 'react';
import MainHeader from './MainHeader';
import Footer from './Footer';
import CliniciansProspect from './CliniciansProspect';
import MobileFooter from './MobileFooter';
import MetaTags from 'react-meta-tags';
import StickyContactMenu from './StickyContactMenu';



class CliniciansTests extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0)
  }

  toCancerTest() {
        window.location.href="/clinicians_cancer-test";
    }

    
    toHeartTest() {

       window.location.href="/clinicians_heart-test";
      }
  render() {
    return (
      

        <div>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
        <link rel="stylesheet" href="https://www.w3schools.com/w3css/4/w3.css" />
        <link href="https://fonts.googleapis.com/css?family=Roboto:100,100i,300,300i,400,400i,500,500i,700,700i,900,900i" rel="stylesheet" />
        {/* <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.8.2/css/all.css" integrity="sha384-oS3vJWv+0UjzBfQzYUhtDYW+Pj2yciDJxpsK1OYPAYjqT085Qq/1cq5FLXAZQ7Ay" crossorigin="anonymous"> */}
        <link rel="stylesheet" href="./fonts/fontawesome-free-5.8.2-web/css/all.css" type="text/css" />
        <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css" integrity="sha384-ggOyR0iXCbMQv3Xipma34MD+dH/1fQ784/j6cY/iJTQUOhcWr7x9JvoRxT2MZw1T" crossOrigin="anonymous" />
        <title>truGeny</title>
        <link rel="icon" href="./img/Logo.png" type="image/gif" sizes="16x16" />
        <link rel="stylesheet" href="./css/header_footer.css" />
        <link rel="stylesheet" href="./css/stylesheet_custom.css" />
        <link rel="stylesheet" href="stylesheet_custom.css" />
        <link rel="stylesheet" href="./css/fonts.css" />
        <link rel="stylesheet" href="./css/sticky.css" />
        <link rel="stylesheet" href="./clinicians_style-mobile2.css"/>
        <link rel="stylesheet" href="./clinicians_style-mobile.css"/>
        <link rel="stylesheet" href="./clinicians_newsticky.css"/>
        <MetaTags>
        <title>Genetic Tests, Hereditary Cancer Test, Cardiac Genetic Test, Prenatal genetic counselling</title>
		<meta name="description" content="truGeny offers clinical grade tests and reports with actionable insights to help you provide better care around genetic disorders. "/>
        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
        <meta property="og:title" content="Genetic Tests, Hereditary Cancer Test, Cardiac Genetic Test, Prenatal genetic counselling"/>
        <meta property="og:site_name" content="truGeny"/>
        <meta property="og:url" content="https://trugeny.com/"/>
        <meta property="og:description" content="truGeny offers clinical grade tests and reports with actionable insights to help you provide better care around genetic disorders. "/>
        <meta property="og:type" content="website"/>
        <meta property="og:image" content=""/>
</MetaTags>
        <style dangerouslySetInnerHTML={{__html: "\n/* @media only screen and (min-width: 1200px)\n{\n/* .custom-pad-mar {\n  padding-left:25rem;\n  padding-right:25rem;\n\n} */\n.genetics-banner-sec-wrap .genetics-banner-sec{\n  background: url(./img/clinicians/test-overview/bg.png) no-repeat center;-webkit-background-size: cover;\n  background-position:center;\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n.gc-help-main-sec{\n  background: url(./img/clinicians/genetic-counseling/bg-2.png) no-repeat center;-webkit-background-size: cover;\n  -moz-background-size: cover;\n  -o-background-size: cover;\n  background-size: cover;\n  background-position: top;\n}\n.gc-help-card-main-wrap .card-deck .card-deck-wrap .card{\n  border:none;\n  margin:0;\n  height:400px;\n    margin-top:3rem;\n}\n\n.pgc-help-main-sec{\n  /* background: url(./img/geneticspage/genetics-session-background.png) no-repeat center;-webkit-background-size: cover; */\n  -moz-background-size: cover;\n  -o-background-size: cover;\n  background-size: cover;\n  background-position: top;\n}\n\n.pgc-help-main-sec .pgc-help-main-wrap{\n  padding-top:130px;\n  padding-bottom:10px;\n  margin:0 auto;\n}\n\n.pgc-help-main-sec .pgc-help-main-wrap h2{\n  font-family: 'Roboto', sans-serif;\n  font-size:2.5rem;\n  font-weight:900;\n  margin:0 auto;\n}\n\n.pgc-help-card-main-wrap .pcard-deck .pcard-deck-wrap{\n  padding:0px 10px;\n  margin:0;\n}\n\n/*.gc-help-card-main-wrap .card-deck .card-deck-wrap:first-child{\n  padding-left:0px!important;\n\n}\n\n.gc-help-card-main-wrap .card-deck .card-deck-wrap:last-child{\n  padding-right:0px!important;\n\n}*/\n\n.pgc-help-card-main-wrap .card-deck .pcard-deck-wrap .card{\n  border:none;\n  margin:0;\n  height:440px;\n  margin-top:4rem;\n}\n\n.pgc-help-main-wrap .card-body .card-block .card-img{\n  height:160px;\n  width:160px;\n}\n\n.pgc-help-main-wrap .card-body .card-text{\n  font-size:1.125rem;\n  font-weight:900;\n}\n\n\n.pgc-help-button-wrap .gc-help-button{\n  padding: 15px 40px;\n  font-weight:bold;\n  font-size:0.875rem;\n  text-transform: uppercase;\n}\n}\n\n" }} />
        <MainHeader category="tests"></MainHeader>
        <div style={{marginTop:'12rem'}}className="margin"></div>
        <div className="container pt-0 pb-2 mt-0 d-none">
          <nav className="navbar container navbar-expand-xl  navbar-light d-none d-lg-block d-xl-block float-left">
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo01" aria-controls="navbarTogglerDemo01" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon">
              </span>
            </button>
            <ul className=" row navbar-nav mr-auto ">
              <li className="nav-item ">
                <a className="nav-link float-right " href="clinicians.html">Clinicians</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="clinicians-genetic-counseling.html">Genetic Counselling </a>
              </li>
              <li className="nav-item">
                {/* <a class="nav-link" href="clinicians-medical-spec.html">Medical Specialities</a> */}
              </li>
              <li className="nav-item ">
                <a className="nav-link" style={{color: '#4f5be7'}} href="clinicians-test-overview.html"><b>Test</b></a>
              </li>
              <li className="nav-item ">
                <a className="nav-link" href="how-does-it-works.html">How does it work?</a>
              </li>
              <li className="nav-item ">
                {/* <a class="nav-link"   href="clinicians-cancer-test.html">Cancer Test</a> */}
              </li>
              <li className="nav-item ">
                {/* <a class="nav-link"   href="clinicians-heart-test.html">Heart Test</a> */}
              </li>
            </ul>
          </nav>
          <br />
          <br />
        </div>{/* eo-container */}
        <section className="genetic-Counseling-main-sec genetics-banner-sec-wrap">
          <div className=" genetics-banner-sec ">
            <div className="container pt-4 mt-2">
              <h1 >Ensure the right genetic test is done for your patients</h1>
              <p className="text-justify mt-3 mb-4">Our clinical grade tests and reports with actionable insights empower you to provide the best quality care around genetic conditions and testing for your patients.</p>
            </div>{/* eo-container*/}
            <div className="d-flex justify-content-center">
              <a style={{scrollBehavior: '[ auto | smooth ]'}} href="#secc11">  <img className="img-fluid d-none d-md-block d-lg-block btn-hover-white1" src="./img/111.png" /></a>
            </div>
          </div>{/* eo-heart-banner-sec */}
        </section>{/* eo-heart-banner-sec-wrap */}
        <StickyContactMenu></StickyContactMenu>
        {/* ------------------------------------------------------heart-banner-sec over------------------------------------------------------------------ */}
        <section className="genetics-informed-sec-main heart-disease-sec-main heart-disease-sec-main " id="#secc11">
          <div className="heart-disease-sec-main-wrap container">
            <div className="genetics-intro-text text-center">
              <h2 className=" text-center genetics-h2 ">truGeny Offers</h2>
            </div>{/* eo-intro-text-wrap*/}
            <div className=" heart-disease-sec row container">
              <div className=" hd-img col-xs-12 col-sm-12 col-md-6 mb-sm-5 mb-xs-5 d-block text-center  ">
                <img className="img-fluid mx-auto" src="./img/clinicians/test-overview/Illustration1.png" />
              </div>{/* eo-hd-img */}
              <div className=" col-xs-12 col-sm-12 col-md-6 mt-md-0 mt-sm-5 mt-xs-5 hd-text align-self-center">
                <h3>truFind - Hereditary Cancer Test</h3>
                <p className="heartdisease-content roboto-bold-18px"><b>7 Lakh new cancer cases are being registered each year in India.</b></p>
                <p className="heartdisease-content">truFind hereditary cancer test enables your patients to understand their genetic risks for developing cancers. When caught at an early stage, patient survival rates for cancers covered by truFind increase significantly.</p>
                <br/>
                <button type="button" className="btn btn-outline-primary mt-2 btn-hover-white rounded-pill my-3"  onClick={this.toCancerTest}>LEARN MORE  &nbsp;<i className="fas fa-long-arrow-alt-right">  &nbsp;</i></button>
              </div>{/* eo-hd-text */}
            </div>{/* eo-row */}
            <div className="families-sec heart-disease-sec row container">
              <div className=" hd-img col-xs-12 col-sm-12 col-md-6 mb-sm-5 mb-xs-5 text-center order-md-2">
                <img className="img-fluid mx-auto" src="./img/clinicians/test-overview/Illustration2.png" />
              </div>{/* eo-hd-img */}
              <div className=" col-xs-12 col-sm-12 col-md-6 mt-md-0 mt-sm-5 mt-xs-5 hd-text align-self-center order-md-1">
                <h3>truHEART - Inherited Heart Conditions Test</h3>
                <p className="heartdisease-content"><b>32 million individuals are affected with Coronary Artery Disease in India</b></p>
                <p className="heartdisease-content">truHEART a polygenic risk score based test for inherited heart conditions helps an individual estimate the genetic predisposition risk for developing Coronary Artery Disease.</p>
                <br/>
                <button type="button" className="btn btn-outline-primary mt-2 btn-hover-white rounded-pill my-3" onClick={this.toHeartTest}>LEARN MORE  &nbsp;  <i className="fas fa-long-arrow-alt-right">  &nbsp;</i></button>
              </div>{/* eo-hd-text */}
            </div>{/* eo-row */}
          </div>{/* eo-heart-disease-sec-main-wrap*/}
        </section>{/* eo-heart-disease-sec-main */}
        <div className="paddingClini">
        </div>
        {/* Start of Genetic Counsell Help cards  */}
        {/* **********Schedule your Genetic Counseling Session Ends Here************** */}
        <CliniciansProspect></CliniciansProspect>
        {/* Footer Links */}
        <Footer></Footer>
        <MobileFooter></MobileFooter>
        {/* -------------------------------------start q and a------------------------------ */}
        <div className="modal fade bd-example-modal-lg d-none" id="exampleModalCenter" tabIndex={-1} role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div className="modal-content" style={{borderRadius: '40px'}}>
              <div className="modal-header bg-blue clearfix border-0" style={{borderTopRightRadius: '40px', borderTopLeftRadius: '40px'}}>
                <h5 className="modal-title" id="exampleModalLongTitle" style={{paddingTop: '5px', paddingBottom: '25px', color: '#2c333c', fontSize: '30px', fontWeight: 700}}>
                  Start your journey in 3 easy steps</h5>
                <button type="button" className="text-center close" data-dismiss="modal" aria-label="Close" style={{paddingTop: '25px', paddingBottom: '25px'}}>
                  <img className="img-fluid" src=".\img\registration\X.png" />
                </button>
                {/* <p class="float-left">Question 1 of 3</p> */}
              </div>
              <div className="bg-blue border-bottom-1">
                <p className="pl-3">Question 1 of 3</p>
              </div>
              <div className="modal-body pb-5 pt-0 m-0">
                <div className="container ">
                  <br />
                  <div className="tab-content">
                    <div id="home" className="container tab-pane active"><br />
                      <h3>How do you indentify your gender?</h3>          <hr />
                      <div className="d-flex d-flex-inline">
                        <img className="mr-3" src="./img/q&a/female.png" alt="" />
                        <img className="mr-3" src="./img/q&a/female.png" alt="" />
                      </div>
                      <div className="float-right pt-2 mt-2">
                        <button type="button" className="btn btn-outline-primary text-center custom-button btn btn-outline-primary btn-hover-white my-2 my-sm-0" data-toggle="pill" href="#menu1">Next</button>
                      </div>
                    </div>
                    <div id="menu1" className=" m-0 p-0 container tab-pane fade"><br />
                      <h3>Does anyone in your family have 2 diabetes?</h3><hr />
                      <h4>Certain ethnic groups have higher risk for diabetes,<br />
                        even at lower body weights.</h4>
                      <div className="col-xs-12 mt-2 ">
                        <div className="input-group-prepend " style={{border: 'solid 1px #ebebeb', maxWidth: '312px'}}>
                          <input type="text" placeholder="Select your ethnicity" className="form-control roboto-reg-16px" style={{border: 'none', height: '60px'}} aria-label="Text input with dropdown button" />
                          <button className="m-0 p-0 btn btn-outline-secondary roboto-bold-14px " href="#" style={{border: 'none', backgroundColor: 'white'}} type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><img className="m-0 p-0" src="img/q&a/carot.png" /></button>
                        </div>
                      </div>
                      <div className="float-right pt-2 mt-2">
                        <button type="button" className="btn btn-outline-primary text-center custom-button btn btn-outline-primary btn-hover-white my-2 my-sm-0" data-toggle="pill" href="#menu2">Next</button>
                      </div>
                    </div>
                    <div id="menu2" className=" m-0 p-0 container tab-pane fade"><br />
                      <h3>Does anyone in your family have 2 diabetes?</h3>
                      <hr />
                      <div className="radio">
                        <label><input type="radio" name="optradio" defaultChecked />  Parents</label>
                      </div>
                      <div className="radio">
                        <label><input type="radio" name="optradio" />  Siblings</label>
                      </div>
                      <div className="float-right pt-2 mt-2">
                        <button className="center-block btn btn-outline-primary btn-hover-white my-2 my-sm-0 center" style={{height: '60px', width: '210px', borderRadius: '30px'}} type="submit"><b>SUBMIT</b></button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* sticky form---------------- */}
              {/* <div class="modal-footer">
                  <button type="button" class="btn btn-secondary"  data-toggle="pill" href="#menu2">Close</button>
                  <button type="button" class="btn btn-primary"  data-toggle="pill" href="#menu1">Next</button>
                </div> */}
            </div>
          </div>
        </div>
        {/* sticky form---------------- */}
     
        {/* --------eo sticky form----------------- */}
        {/* ----------------------------------------------------eo Q and A--------------------------------- */}
        {/* Optional JavaScript */}
        {/* jQuery first, then Popper.js, then Bootstrap JS */}
      </div>
    );
  }
}
export default CliniciansTests;
